import React, { useState, useEffect } from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import {MessageCircle, MessageCircleOff, Star, UserRound} from "lucide-react";
import { useTranslation } from "react-i18next";
import {
    Button, Dialog, DialogContent, DialogTitle,
    IconButton, Typography, useMediaQuery, CircularProgress
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import axios from 'axios';
import { theme } from "../../../../../config/design/theme";
import SubTitle from "../../../../components/elements/SubTitle";
import {defaultVariables} from "../../../../../config";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {Link} from "react-router-dom";
import {getDisplayDate, showSimpleDate} from "../../../../../config/values";

function CommentsButton({ classes,data }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const config = {
        headers: {
            Accept: 'application/json',
        },
    };

    const loadData = () => {
        setLoading(true);
        setError(null);

        axios
            .get(`${defaultVariables.url}/front/vendor-comments/${data.slug}`, config)
            .then((response) => {
                setComments(response.data || []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching comments:", error);
                setError(t('Failed to load comments'));
                setLoading(false);
            });
    };

    // Load data when the dialog opens
    useEffect(() => {
        if (open) {
            loadData();
        }
    }, [open]);

    return (
        <div>
            {isMobile ? (
                <IconButton onClick={() => setOpen(true)}>
                    <MessageCircle className="lucide-large" />
                </IconButton>
            ) : (
                <Button
                    startIcon={<MessageCircle className="lucide-small" />}
                    onClick={() => setOpen(true)}
                >
                    {t('comments')} {!!data.comments_count && `(${data.comments_count})`}
                </Button>
            )}
            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    <SubTitle component="span" align="left" className="dialog-title">
                        {data.name} {t('comments')}
                    </SubTitle>
                    <IconButton
                        onClick={() => setOpen(false)}
                        size="small"
                        className={classes.dialogClose}
                    >
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {loading ? (
                        <div style={{ textAlign: 'center' }}>
                            <AppCardLoaderFields />
                        </div>
                    ) : error ? (
                        <Typography color="error" align="center">
                            {error}
                        </Typography>
                    ) : comments.length === 0 ? (
                        <div className="text-center bg-gray-box" style={{padding:'70px 0'}}>
                            <MessageCircleOff className="lucide-icon-primary mb-20" style={{width:40,height:40}}/>
                            <Typography align="center">
                                {t('noCommentsAvailable')}
                            </Typography>
                        </div>
                    ) : (
                        comments.map((comment, index) => (
                            <div key={index} className="bg-gray-box mb-15 position-relative">
                                <div className="flex-direction mb-5" style={{gap:5}}>
                                    <UserRound className="lucide-small"/>
                                    <Typography variant="subtitle1" className="bold">
                                        {comment.user?.first_name}
                                    </Typography>

                                </div>
                                <Typography align="left" color="text" className="mb-20">
                                    {comment.comment}
                                </Typography>
                                <div className='rating-holder rating-vendor'>
                                    <div className="date-box star-comment">
                                        <span >{getDisplayDate(comment.created_at)}</span>
                                    </div>
                                    <span className="flex-direction ml-10" style={{gap:0, fontSize:14}}>
                                        <Star className="rating-icon" style={{marginRight:3}} />
                                        {comment.rate}
                                    </span>

                                </div>


                                {comment.products && comment.products.length > 0 && (
                                    <Typography  className="comment-products">
                                        {
                                            comment.products.map((product,index) => (
                                                <React.Fragment key={index}>
                                                    <span>
                                                        {product.name}
                                                    </span>
                                                </React.Fragment>
                                            ))
                                        }
                                    </Typography>
                                )}
                            </div>
                        ))
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default withStyles(Styles)(CommentsButton);
